export default __webpack_public_path__ + "static/media/indexxHiveHoneyBee.817462d2.svg";